export const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__" as const;
